"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACRadioGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var antd_1 = require("antd");
var react_1 = require("react");
var react_toastify_1 = require("react-toastify");
var utils_1 = require("../utils");
var ACSkeletonRadioGroup_1 = require("./ACSkeletonRadioGroup");
var ACWrapperContext_1 = require("./ACWrapperContext");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
var ACRadioGroup = function (props) {
    var _a = (0, react_1.useState)(Boolean(props === null || props === void 0 ? void 0 : props.endPoint)), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(props.disabled), isDisabled = _b[0], setIsDisabled = _b[1];
    var memoizedOptions = (0, react_1.useMemo)(function () { return props.options; }, [props.options]);
    var _c = (0, react_1.useState)([]), options = _c[0], setOptions = _c[1];
    var _d = (0, react_1.useState)(props.value), selectedValue = _d[0], setSelectedValue = _d[1];
    var optionType = (props === null || props === void 0 ? void 0 : props.variant) === 'circled' ? 'default' : 'button';
    (0, react_1.useEffect)(function () {
        if (props === null || props === void 0 ? void 0 : props.endPoint) {
            API_GET_Options();
        }
    }, [props === null || props === void 0 ? void 0 : props.endPoint]);
    (0, react_1.useEffect)(function () {
        setIsDisabled(props.disabled);
    }, [props.disabled]);
    (0, react_1.useEffect)(function () {
        setSelectedValue(props.value);
    }, [props.value]);
    var API_GET_Options = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, endPoint, rootState, _b, functionName, params, endpoint, ParentUtils, func, res, data, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _a = props.endPoint, endPoint = _a === void 0 ? '' : _a, rootState = props.rootState, _b = props.function, functionName = _b === void 0 ? '' : _b;
                    params = (props === null || props === void 0 ? void 0 : props.params) || {};
                    return [4 /*yield*/, utils_1.Utils.getProcessedEndpoint({
                            params: params,
                            endPoint: endPoint,
                            rootState: rootState,
                        })];
                case 1:
                    endpoint = _c.sent();
                    ParentUtils = (0, ACWrapperContext_1.getUtils)();
                    func = ParentUtils[functionName] || ParentUtils.makeApiCall;
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, 5, 6]);
                    return [4 /*yield*/, func("".concat(endpoint), 'GET')];
                case 3:
                    res = _c.sent();
                    if (!res.status) {
                        react_toastify_1.toast.error(res.message, {
                            position: 'top-center',
                            autoClose: 2000,
                        });
                        return [2 /*return*/];
                    }
                    data = res.data.map(function (option) { return (__assign(__assign({}, option), { label: (option === null || option === void 0 ? void 0 : option.label) || (option === null || option === void 0 ? void 0 : option[(props === null || props === void 0 ? void 0 : props.optionLabelKey) || '']), value: (option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option[(props === null || props === void 0 ? void 0 : props.optionValueKey) || '']) })); });
                    setOptions(__spreadArray([], data, true));
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _c.sent();
                    react_toastify_1.toast.error('Error', {
                        position: 'top-center',
                        autoClose: 2000,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (option) {
        setSelectedValue(option);
        if (props.onChange) {
            props.onChange(option);
        }
    };
    var getButtonStyle = function (option) {
        return selectedValue === option ? props.activeClassName : props.className;
    };
    var ops = props.endPoint ? options : memoizedOptions;
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props, { variant: optionType })), loading ? ((0, jsx_runtime_1.jsx)(ACSkeletonRadioGroup_1.ACSkeletonRadioGroup, {})) : ((0, jsx_runtime_1.jsx)(antd_1.Radio.Group, { optionType: optionType, buttonStyle: props.buttonStyle, className: "".concat(optionType !== 'default' ? "apx-ui_radio__group ".concat((props === null || props === void 0 ? void 0 : props.variant) || '') : '', " ").concat((props === null || props === void 0 ? void 0 : props.size) || '', " ").concat(props.radioGroupClassName), value: selectedValue, children: ops &&
                    ops.map(function (option) {
                        return ((0, jsx_runtime_1.jsxs)(antd_1.Radio, { onChange: function () {
                                handleChange(option === null || option === void 0 ? void 0 : option.value);
                            }, value: option.value, disabled: isDisabled, className: getButtonStyle(option === null || option === void 0 ? void 0 : option.value), children: [(option === null || option === void 0 ? void 0 : option.icon) ? ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat(option === null || option === void 0 ? void 0 : option.icon, " ").concat(option === null || option === void 0 ? void 0 : option.iconClassName) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), (0, jsx_runtime_1.jsxs)("span", { className: "flex items-center gap-1", children: [(props === null || props === void 0 ? void 0 : props.showValueAsPrefix) && ((0, jsx_runtime_1.jsx)("span", { className: "apx-ui_radio__group--prefix", children: option === null || option === void 0 ? void 0 : option.value })), option.label] })] }, option.value));
                    }) }))] }));
};
exports.ACRadioGroup = ACRadioGroup;
